export default "/_next/static/images/product_messenger-9ac99858cfd5ddee38d2e33d7512ce12.svg";